import { render, staticRenderFns } from "./CoronaModal.vue?vue&type=template&id=4547a9a8&scoped=true&"
import script from "./CoronaModal.vue?vue&type=script&lang=js&"
export * from "./CoronaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547a9a8",
  null
  
)

export default component.exports